import { NavLink, useNavigate } from 'react-router-dom';
import {
	LayoutDashboard,
	Users,
	DollarSign,
	Gamepad2,
	Play,
	Key,
	FileBarChart,
	LogOut,
	Castle,
	BookOpen,
	ExternalLink,
} from 'lucide-react';
import { useAuthStore } from '../lib/store';
import styles from './Layout.module.css';

interface LayoutProps {
	children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
	const { user, logout } = useAuthStore();
	const navigate = useNavigate();

	const handleLogout = () => {
		logout();
		navigate('/login');
	};

	return (
		<div className={styles.layout}>
			{/* Sidebar */}
			<aside className={styles.sidebar}>
				<div className={styles.logo}>
					<Castle size={24} className={styles.logoIcon} />
					<span className={styles.logoText}>Ringfort <span className={styles.logoSuffix}>Studio</span></span>
				</div>

				<div className={styles.operatorBadge}>
					<span className={styles.operatorLabel}>Operator</span>
					<span className={styles.operatorName}>{user?.operatorName || 'Dashboard'}</span>
				</div>

				<nav className={styles.nav}>
					<NavLink to="/" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`} end>
						<LayoutDashboard size={20} />
						<span>Dashboard</span>
					</NavLink>
					<NavLink to="/players" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
						<Users size={20} />
						<span>Players</span>
					</NavLink>
					<NavLink to="/bets" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
						<DollarSign size={20} />
						<span>Bets</span>
					</NavLink>
					<NavLink to="/games" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
						<Gamepad2 size={20} />
						<span>Games</span>
					</NavLink>
					<NavLink to="/demo" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
						<Play size={20} />
						<span>Demo Play</span>
					</NavLink>
					<NavLink to="/api-keys" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
						<Key size={20} />
						<span>API Keys</span>
					</NavLink>
					<NavLink to="/reports" className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}>
						<FileBarChart size={20} />
						<span>Reports</span>
					</NavLink>

					<a
						href="/docs"
						target="_blank"
						rel="noopener noreferrer"
						className={styles.navItem}
					>
						<BookOpen size={20} />
						<span>API Docs</span>
						<ExternalLink size={14} className={styles.externalIcon} />
					</a>
				</nav>

				<div className={styles.userSection}>
					<div className={styles.userInfo}>
						<div className={styles.avatar}>{user?.email?.charAt(0).toUpperCase() || 'U'}</div>
						<div className={styles.userDetails}>
							<span className={styles.userName}>{user?.email || 'User'}</span>
							<span className={styles.userRole}>{user?.role || 'operator'}</span>
						</div>
					</div>
					<button onClick={handleLogout} className={styles.logoutBtn} title="Logout">
						<LogOut size={18} />
					</button>
				</div>
			</aside>

			{/* Main content */}
			<main className={styles.main}>{children}</main>
		</div>
	);
}
